var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66333 11.3267C6.89321 11.3267 8.02735 10.929 8.95529 10.2662L12.4461 13.757C12.6081 13.919 12.8217 14 13.05 14C13.5287 14 13.8674 13.6318 13.8674 13.1604C13.8674 12.9395 13.7938 12.7259 13.6318 12.5713L10.1631 9.09521C10.8922 8.13782 11.3267 6.95213 11.3267 5.66334C11.3267 2.54813 8.77854 0 5.66333 0C2.5555 0 0 2.54077 0 5.66334C0 8.77854 2.54813 11.3267 5.66333 11.3267ZM5.66333 10.1042C3.23304 10.1042 1.22251 8.09364 1.22251 5.66334C1.22251 3.23304 3.23304 1.22251 5.66333 1.22251C8.09363 1.22251 10.1042 3.23304 10.1042 5.66334C10.1042 8.09364 8.09363 10.1042 5.66333 10.1042Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.2ab3538bb5428db41ea0df9a22cdcfd3.svg";
export { ForwardRef as ReactComponent };